<template>
  <div class="w-full pt-2 pb-0 px-0 flex gap-4 justify-center items-center">
    <div class="flex flex-col w-full max-w-xs">
      <input
        type="text"
        name="tagName"
        v-model="tagName"
        placeholder="نام تگ جدید را وارد کنید"
        class="input"
        :class="{ 'border-red-500': errors.tagName }"
      />
      <span v-if="errors.tagName" class="text-red-500 text-xs mt-1">
        {{ errors.tagName }}
      </span>
    </div>
    <button
      @click="handleSubmit"
      class="flex gap-2 items-center border-emerald-100 text-emerald-400 border py-2 px-4 rounded-lg transition-colors hover:bg-emerald-100 text-nowrap mobile:text-sm"
    >
      افزودن تگ
    </button>
  </div>
</template>

<script setup>
import { postTag } from "@/services/api/apiServiceLeads";
import { useMutation } from "@tanstack/vue-query";
import Swal from "sweetalert2";
import { defineEmits, ref } from "vue";

const tagName = ref("");
const errors = ref({ tagName: "" }); // Error messages for validation
defineEmits(["close"]);

const { mutate } = useMutation({
  mutationFn: postTag,
  onSuccess: () => {
    Swal.fire({
      icon: "success",
      title: "تگ با موفقیت اضافه شد.",
      showConfirmButton: false,
      timer: 1500,
    });
    resetForm();
  },
  onError: () => {
    Swal.fire({
      icon: "error",
      title: "افزودن تگ با شکست مواجه شد!",
      showConfirmButton: false,
      timer: 1500,
    });
  },
});

// Form validation function
function validateForm() {
  let isValid = true;

  if (!tagName.value.trim()) {
    errors.value.tagName = "نام تگ الزامی است.";
    isValid = false;
  } else {
    errors.value.tagName = "";
  }

  return isValid;
}

async function handleSubmit() {
  if (validateForm()) {
    mutate(tagName.value);
  }
}

// Reset form and errors after successful submission
function resetForm() {
  tagName.value = "";
  errors.value = { tagName: "" };
}
</script>

<style>
.input {
  border: 1px solid #e2e8f0;
  padding: 0.5rem;
  border-radius: 0.375rem;
  width: 100%;
  outline: none;
  transition: border-color 0.2s ease-in-out;
}

.input:focus {
  border-color: #3182ce;
}

.input.border-red-500 {
  border-color: #f56565;
}
</style>
